module.exports = __webpack_public_path__ + "img/title-bg.d5fbe666.png";